import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import apiClient from '../../api';
import './ForgotPassword.css';
import 'font-awesome/css/font-awesome.min.css';

function ResetPassword() {
    const location = useLocation();
    const navigate = useNavigate();
    const token = new URLSearchParams(location.search).get('token');

    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false); // Nuevo estado para ver pass
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        if (newPassword !== confirmPassword) {
            setError('Las contraseñas no coinciden');
            return;
        }

        setIsLoading(true);
        try {
            await apiClient.post('/password/reset', { token, newPassword });
            setSuccess('Contraseña restablecida correctamente');
            setTimeout(() => navigate('/'), 3000);
        } catch (err) {
            if (err.response?.status === 400) {
                setError('El enlace ha caducado o no es válido.');
            } else {
                setError('No se pudo restablecer la contraseña. Inténtalo de nuevo.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    if (!token) {
        return (
            <div className="forgot-page-wrapper">
                <div className="auth-card">
                    <div className="error-banner">
                        <i className="fa fa-times-circle"></i> Token no válido o ausente.
                    </div>
                    <div className="back-link" style={{ marginTop: '20px' }}>
                        <button onClick={() => navigate('/')} className="action-button">
                            Volver al inicio
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="forgot-page-wrapper">
            <div className="auth-card">

                {success ? (
                    <div className="success-state">
                        <div className="success-icon">
                            <i className="fa fa-check"></i>
                        </div>
                        <div className="auth-header">
                            <h1>¡Contraseña Actualizada!</h1>
                        </div>
                        <div className="success-text">
                            Has cambiado tu contraseña con éxito. <br/>
                            Te estamos redirigiendo al login...
                        </div>
                        <div className="back-link">
                            <i className="fa fa-spinner fa-spin" style={{ color: 'var(--brand-primary)' }}></i>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="auth-header">
                            <h1>Nueva Contraseña</h1>
                            <p className="auth-subtitle">Introduce tu nueva clave para acceder.</p>
                        </div>

                        {error && (
                            <div className="error-banner">
                                <i className="fa fa-exclamation-circle"></i> {error}
                            </div>
                        )}

                        <form onSubmit={handleSubmit} className="auth-form">
                            <div className="form-group password-wrapper" style={{ position: 'relative' }}>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    placeholder="Nueva contraseña"
                                    required
                                    disabled={isLoading}
                                    style={{ paddingRight: '45px' }}
                                />
                                <button
                                    type="button"
                                    className="toggle-password"
                                    onClick={() => setShowPassword(!showPassword)}
                                    style={{
                                        position: 'absolute',
                                        right: '0',
                                        top: '0',
                                        height: '100%',
                                        width: '45px',
                                        border: 'none',
                                        background: 'transparent',
                                        cursor: 'pointer',
                                        color: 'var(--text-muted)'
                                    }}
                                >
                                    <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                </button>
                            </div>

                            <div className="form-group">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    placeholder="Confirmar contraseña"
                                    required
                                    disabled={isLoading}
                                />
                            </div>

                            <button
                                type="submit"
                                className="action-button"
                                disabled={isLoading}
                            >
                                {isLoading ? 'Actualizando...' : 'Guardar Nueva Contraseña'}
                            </button>
                        </form>
                    </>
                )}
            </div>
        </div>
    );
}

export default ResetPassword;